import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getCurrentEmployee, logoutWithPIN } from '../../services/pinAuthService';
import styles from './EmployeeLayout.module.css';

interface EmployeeLayoutProps {
  children: React.ReactNode;
}

export const EmployeeLayout: React.FC<EmployeeLayoutProps> = ({ children }) => {
  const employee = getCurrentEmployee();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    logoutWithPIN();
    navigate('/employee/login');
  };

  const menuItems = [
    { path: '/employee', label: 'MY SHIFTS' },
    { path: '/employee/qr', label: 'MY QR CODE' },
    { path: '/employee/history', label: 'REDEMPTION HISTORY' },
  ];

  const isActive = (path: string) => {
    if (path === '/employee') {
      return location.pathname === '/employee' || location.pathname.startsWith('/employee/');
    }
    return location.pathname === path;
  };

  return (
    <div className={styles.employeeLayout}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.logo}>
          <h1>REFUGE</h1>
          <p className={styles.role}>EMPLOYEE PORTAL</p>
        </div>

        <div className={styles.userSection}>
          {employee && (
            <>
              <div className={styles.userAvatar}>
                {employee.name.charAt(0).toUpperCase()}
              </div>
              <div className={styles.userInfo}>
                <div className={styles.userName}>{employee.name}</div>
                <div className={styles.userRole}>Employee</div>
              </div>
            </>
          )}
          <button onClick={handleLogout} className={styles.logoutButton}>
            LOG OUT
          </button>
        </div>
      </div>

      {/* Navigation */}
      <div className={styles.nav}>
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`${styles.navItem} ${isActive(item.path) ? styles.active : ''}`}
          >
            {item.label}
          </Link>
        ))}
      </div>

      {/* Main content */}
      <div className={styles.mainContent}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};